/**
 * Custom hook to ensure services always have the latest auth context
 * This hook automatically updates the service context with current auth data
 */

import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext.tsx';
import { serviceFactory } from '@/services';
import type { BaseService } from '@/services';

export function useServiceWithAuth<T extends BaseService>(
  ServiceClass: new (context: any) => T
): T {
  const { user, hasuraToken, token } = useAuth();
  
  // Get service instance
  const service = serviceFactory.getService(ServiceClass);
  
  // Update service context whenever auth data changes
  useEffect(() => {
    if (user && hasuraToken) {
      service.updateContext({
        userId: user.id,
        hasuraToken,
        userType: user.type,
        token
      });
    }
  }, [user, hasuraToken, token, service]);
  
  return service;
}